<template>
    <list-page icone="mdi-earth-box" titulo="Região/Grupo" @novo="Novo()" @atualizar="Listar()" :temBuscaRapida="true" :buscaRapida.sync="search" >
        <template v-slot:corpo>

          <v-data-table id="tabela" :headers="headers" :items="lista" :options.sync="options" :server-items-length="totalLista" :loading="loading" class="elevation-1">
            
            <template v-slot:[`item.actions`]="{ item }">

              <v-tooltip right>
                <template v-slot:activator="{ on }">
                  <v-icon small @click="Editar(item)" v-on="on">mdi-pencil</v-icon>
                </template>
                <span>Editar</span>
              </v-tooltip>

              <v-tooltip right>
                <template v-slot:activator="{ on }">
                  <v-icon small @click="Excluir(item)" v-on="on">mdi-delete</v-icon>
                </template>
                <span>Excluir</span>
              </v-tooltip>

            </template>

          </v-data-table>

          <!-- <v-data-table :headers="headers" :items="lista" :options.sync="options" :server-items-length="totalLista" :loading="loading" class="elevation-1">
            <template v-slot:body="{ items }">
              <tbody>
                <tr v-for="item in items" :key="item.id">
                    <td class="justify-center layout px-0">
                      <v-tooltip right>
                        <template v-slot:activator="{ on }">
                          <v-icon small @click="Editar(item)" v-on="on">mdi-pencil</v-icon>
                        </template>
                        <span>Editar</span>
                      </v-tooltip>
                      <v-tooltip right>
                        <template v-slot:activator="{ on }">
                          <v-icon small @click="Excluir(item)" v-on="on">mdi-delete</v-icon>
                        </template>
                        <span>Excluir</span>
                      </v-tooltip>
                    </td>
                    <td>{{ item.nome }}</td>
                    <td>{{ item.composicao }}</td>
                </tr>
              </tbody>
            </template>
          </v-data-table> -->

          <v-overlay :value="primeiraCarga">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
          </v-overlay>

          <cadastro-regiao v-model="dialogCadastro" :item="item" @fechou="dialogCadastro = false" @salvou="Listar()"/>

        </template>
    </list-page>
</template>
<script>
import RegiaoService from '@/core/services/doacao/RegiaoService';
import Regiao from '@/core/domain/doacao/Regiao';
import ListPage from "@/components/shared/ListPage";

export default {
    extends: ListPage,
    data: () => ({
      headers: [
        { text: '', value:'actions', sortable: false  },
        { text: 'Nome', value: 'nome' },
        { text: 'Composição', value: 'composicao' }
      ],
      primeiraCarga: true
    }),
    watch:{
      lista: function(){
        if(this.primeiraCarga)
          this.primeiraCarga = false;
      }
    },
    created() {
      this.service = new RegiaoService();
    },
    methods: {
      Novo(){
        this.NovoCadastro(new Regiao());
      },
      Editar(item){
        this.service.ObterPorId(item.id)
          .then(
            res =>{
              this.EditarCadastro(new Regiao(res.data));
            },
            err => this.$swal('Aviso', err.response.data, 'error')
          )
      }
    },
    mounted() {
      this.Listar()
    }
}
</script>
<style scoped>

</style>
